/**
 * Generate dynamic next year expiration text based on current date
 * If current date is before August 15th of current year, show next year (current + 1)
 * If current date is after August 15th of current year, show year after next (current + 2)
 */
export const getDynamicNextYearExpirationText = (): string => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const august15CurrentYear = new Date(currentYear, 7, 15); // Month is 0-indexed, so 7 = August

  let targetYear: number;

  if (currentDate <= august15CurrentYear) {
    // Current date is before or on August 15th of current year
    targetYear = currentYear + 1; // Next year
  } else {
    // Current date is after August 15th of current year
    targetYear = currentYear + 2; // Year after next
  }

  return `Copy link expiring 8/15/${targetYear}`;
};
